module.exports = __webpack_public_path__ + "img/logo-green.5174633d.svg";